// Mesh names from YatCube GLTF model
export enum FaceName {
    f6 = 'face6',
    f5 = 'face5',
    f3 = 'face1',
    f2 = 'face3',
    f4 = 'face4',
    f1 = 'face2',
}

// This matches the order of the liquidIDItems in the redux store
export const FACE_NAMES: FaceName[] = Object.values(FaceName);

export const LID_LAYER_ID = 'liquid-id';
